@if(layoutService.config.settings.icon === 'stroke-svg'){
<svg class="stroke-icon">
    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{icon}}"></use>
</svg>
}
@else{
<svg class="fill-icon">
    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{icon}}"></use>
</svg>
}